const _ = require("lodash");
const ParserHelpers = require("../util/ParserHelpers");
const ColorUtil = require("../../util/ColorUtil");
const cS = ColorUtil.getCurrentScheme();

const elevatorButtonParser = function(ps) {
	const optArg = ParserHelpers.findOptionalArgument(ps);
	const optArgText = optArg && optArg.getRest().trim();
	const textOnly = optArgText === "textOnly" ? true : false;
	const reqArgs = ParserHelpers.findArguments(ps, 1, {requireBrace: true});
	if (!reqArgs) {
		ps.pushError(
			"elevatorButton requires a command or dot for ellipses (., 1, 2, 3, 4, 5, -1, -2, -3, -4 or -5)"
		);
		return false;
	}

	const command = reqArgs[0].text;
	if (!/(^[\-\+]?[1-5]$)|(^\.$)/.test(command)) {
		ps.pushError(
			"elevatorButton requires a command or dot for ellipses (., 1, 2, 3, 4, 5, -1, -2, -3, -4 or -5)"
		);
		return false;
	}

	const textNodes = {};
	if (command === ".") {
		textNodes.ellipses = {
			type: "text",
			text: "...",
		};
	} else {
		const direction = command[0] === "-" ? "-" : "+";
		const numFloors = command[command.length - 1];

		textNodes.symbol = {
			type: "text",
			text: direction,
		};

		textNodes.floors = {
			type: "text",
			text: numFloors,
		};
	}

	return [
		{
			type: "elevatorButton",
			textNodes,
			textOnly,
		},
	];
};

const textPosition = {
	textOnly: {
		"+": {
			symbolCenter: 0.31,
			floorsCenter: 0.69,
		},
		"-": {
			symbolCenter: 0.27,
			floorsCenter: 0.66,
		},
	},
	circle: {
		"+": {
			symbolCenter: 0.34,
			floorsCenter: 0.66,
		},
		"-": {
			symbolCenter: 0.35,
			floorsCenter: 0.61,
		},
	},
};

const elevatorButtonNode = {
	draw(rc, x, y, node, measure) {
		const {top, width} = measure;
		const context = rc.context;

		if (!node.textOnly) {
			context.save();
			context.strokeStyle = cS.elevatorRidesButtonText;
			context.lineWidth = 2;
			context
				.bp()
				.arc(x + top, y, top * 0.9, 0, Math.PI * 2)
				.stroke();
			context.restore();
		}
		const {textNodes} = node;
		const {tMeasure} = measure;
		const {symbol, floors, ellipses} = textNodes;

		context.save();
		context.fillStyle = cS.elevatorRidesButtonText;

		const type = node.textOnly ? "textOnly" : "circle";
		const direction = _.get(node, "textNodes.symbol.text", "-");

		if (symbol) {
			const symbolCenter =
				x + textPosition[type][direction].symbolCenter * width;
			const symbolLeft = symbolCenter - tMeasure.symbol.width / 2;
			rc.drawNode(rc, symbolLeft, y, symbol, tMeasure.symbol);
		}
		if (floors) {
			const floorsCenter =
				x + textPosition[type][direction].floorsCenter * width;
			const floorsLeft = floorsCenter - tMeasure.floors.width / 2;
			rc.drawNode(rc, floorsLeft, y, floors, tMeasure.floors);
		}
		if (ellipses) {
			const ellipsesCenter = x + width / 2;
			const ellipsesLeft = ellipsesCenter - tMeasure.ellipses.width / 2;
			rc.drawNode(rc, ellipsesLeft, y, ellipses, tMeasure.ellipses);
		}

		context.restore();
	},

	measure(rc, fontInfo, props, node) {
		const baseWidth = node.textOnly ? fontInfo.size * 1.5 : fontInfo.size * 2;
		const newFontInfo = _.cloneDeep(fontInfo);
		_.extend(newFontInfo, {
			size: node.textOnly ? fontInfo.size * 1.2 : fontInfo.size,
			family: ["Roboto"],
			bold: true,
		});

		const tMeasure = {};
		_.forOwn(
			node.textNodes,
			(textNode, key) =>
				(tMeasure[key] = rc.measureNode(rc, newFontInfo, props, textNode))
		);

		let width = baseWidth;
		if (node.textOnly && !node.textNodes.ellipses) {
			if (node.textNodes.symbol.text === "+") {
				width *= 1.25;
			} else {
				width *= 1.1;
			}
		}
		return {
			width,
			top: baseWidth / 2,
			bottom: baseWidth / 2,
			fontInfo,
			tMeasure,
		};
	},

	readAloud: function(node, context) {
		if (node.textNodes.ellipses) {
			return null;
		} else {
			const direction = node.textNodes.symbol.text === "+" ? "up" : "down";
			return `${direction} ${node.textNodes.floors.text}`;
		}
	},
};

module.exports = {
	parsers: {
		mathCommands: {
			elevatorButton: elevatorButtonParser,
		},
	},
	nodes: {
		elevatorButton: elevatorButtonNode,
	},
};
